import { type ComponentType } from 'react';

import { AIAgentIcon } from '@/modules/aiAgents/icons/AIAgentIcon';
import { type CreateAIAgentOptions } from '@/modules/aiAgents/models';

const brainIconCache = new Map<string, ComponentType<{ size?: number }>>();

export const getBrainIcon = (brainType: string): ComponentType<{ size?: number }> => {
  let icon = brainIconCache.get(brainType);
  if (!icon) {
    icon = (props: { size?: number }) => (
      <AIAgentIcon type={brainType as CreateAIAgentOptions} {...props} />
    );
    brainIconCache.set(brainType, icon);
  }
  return icon;
};
